import { useState, useEffect } from 'react';

const STORAGE_KEY = 'visaly_disclaimer_accepted';
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

export default function DisclaimerModal() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const ts = parseInt(stored, 10);
      if (Date.now() - ts < THIRTY_DAYS_MS) return;
    }
    setVisible(true);
  }, []);

  function accept() {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-cream-app rounded-3xl border-2 border-ink max-w-lg w-full p-6 md:p-8 animate-fade-in">
        <div className="text-center mb-5">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-violet-100 mb-3">
            <svg className="w-6 h-6 text-violet-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
          </div>
          <h2 className="font-display text-lg text-slate-900">
            Information importante
          </h2>
        </div>

        <div className="space-y-3 text-sm text-slate-600 leading-relaxed">
          <p>
            <strong className="text-slate-900">Visaly est un outil d'aide
            &agrave; la d&eacute;cision.</strong> Il vous permet de pr&eacute;-scorer la conformit&eacute;
            de vos communications au regard de la r&eacute;glementation fran&ccedil;aise de la
            publicit&eacute; des produits de sant&eacute; (m&eacute;dicaments grand public,
            compl&eacute;ments alimentaires, cosm&eacute;tiques, dispositifs m&eacute;dicaux).
          </p>
          <p>
            Cependant, <strong className="text-slate-900">cet outil ne remplace ni la
            revue r&eacute;glementaire du laboratoire, ni le visa de l'ANSM, ni un avis
            juridique</strong>. Les analyses fournies sont indicatives et ne constituent ni un avis
            juridique, ni une garantie de conformit&eacute;. Visaly n'est pas affili&eacute; &agrave;
            l'ANSM.
          </p>
          <p>
            Que vous soyez un laboratoire, une agence, un cr&eacute;ateur de contenu ou tout autre
            professionnel, <strong className="text-slate-900">toute d&eacute;cision
            engageant votre responsabilit&eacute; juridique doit &ecirc;tre valid&eacute;e par un
            professionnel qualifi&eacute;</strong> (affaires r&eacute;glementaires, pharmacien
            responsable, avocat).
          </p>
        </div>

        <button
          onClick={accept}
          className="btn-ink font-display mt-6 w-full py-3"
        >
          J'ai compris et j'accepte
        </button>

        <p className="mt-3 text-center text-[10px] text-slate-400">
          Ce message s'affiche une fois par mois.
        </p>
      </div>
    </div>
  );
}
